/**
 * External dependencies
 */
import React, { useState } from "react";
import { Box, Text } from "@towersystems/towersystems-design-system";
import { TowerProvider } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */

import Button from "components/button";
import ButtonGroup from "components/button-group";

/**
 * Style dependencies
 */
import "./styles.scss";

const SetDefaultPrompt = ({
  dashboardId,
  onClose,
  message,
  title,
  ...props
}) => {
  const [saving, setSaving] = useState(false);

  return (
    <TowerProvider>
      <Box className="react-confirm-alert-body">
        <Box align="center">
          <Text size="large" weight="medium" align="center">
            {title}
          </Text>
        </Box>
        <Box size="medium" align="center">
          {message}
        </Box>
        <Box marginTop="xlarge">
          <ButtonGroup justifyContent="center">
            <Button onClick={onClose} secondary lined>
              Cancel
            </Button>
            <Button
              onClick={async () => {
                setSaving(true);
                await props.savePreference("defaultDashboard", dashboardId);
                onClose();
              }}
              secondary
              borderless
              disabled={saving}
            >
              Yes, set default.
            </Button>
          </ButtonGroup>
        </Box>
      </Box>
    </TowerProvider>
  );
};

export default SetDefaultPrompt;
